import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    videoUploadModal: false,
    videoURL: '',
    isVideoUrlUploadModal: false,
    videoUploadProgressPercentage: 0,
    publishProgressPercentage: 0,
    previewFile: false,
    videoDetails: {
        file: {},
        name: '',
        length: 0,
        type: '',
        source: {},
    }
}

const videoCreateSlice = createSlice({
    name: 'Videos',
    initialState,
    reducers: {
        openVideoModal: (state, action) => {
            state.videoUploadModal = true;
        },
        videoUrlChanged: (state, action) => {
            state.videoURL = action.payload
        },
        openVideoUrlModal: (state, action) => {
            state.isVideoUrlUploadModal = true
        },
        resetVideoModalState: (state, action) => initialState,
        changePublishPercentage: (state, action) => {
            state.publishProgressPercentage = action.payload
        },
        changeVideoUploadProgressPercentage: (state, action) => {
            state.videoUploadProgressPercentage = action.payload
        },
        previewPublishedFile: (state, action) => {
            state.previewFile = true
        },
        addVideoDetails: (state, action) => {
            state.videoDetails = action.payload
        },
    }
});

const { actions, reducer } = videoCreateSlice;
export default reducer;
export const videoActions = actions;